module.exports = __webpack_public_path__ + "static/media/softwareBg1.d135965f.jpg";